import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_2 = {
  key: 1
};
import { searchFormItems, editFormItems, editRules, addFormItems, addRules } from './config';
import { BASE_URL, PAGE_URL, updateUseFlag, updateLocationEnable, remove, getAdminLocalVer, updateAdminLocalVer } from '@/api/baseSetting/anchorpoint/anchorpoint';
import { Edit, Delete } from '@element-plus/icons-vue';
import { deleteBox, toast, warningBox } from '@/utils/message';
import { XTable } from '@/components/index';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import useStore from "@/store";
import { formatterDate } from '@/utils/common';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Anchorpoint',
  setup(__props) {
    const tableInstance = ref();
    const addFormInstance = ref();
    const editFormInstance = ref();
    let searchData = {};
    let adminLocalVer = ref('0');
    const headerButton = [
      // tableAddHeader(() => {
      //   addFormInstance.value?.open()
      // }),
      // tableEditHeader((rows: any[]) => {
      //   if(isOnlyOne(rows)) {
      //     editFormInstance.value?.open(rows[0].id)
      //   }
      // }),
      // tableDeleteHeader((rows: any[]) => {
      //   if(rows.length === 0) {
      //     toast.warn('请至少选择一条数据')
      //     return
      //   }
      //   deleteBox().then(() => {
      //     remove(rows.map(i => i.id)).then(() => {
      //       toast.success('删除成功')
      //       tableInstance.value?.load(searchData)
      //     })
      //   })
      // }),
    ];
    const handleUpdateAdminLocalVer = () => {
      var adminLocalVerData = {
        id: 1,
        status: adminLocalVer.value
      };
      var noticeMsg = adminLocalVer.value === '0' ? '确认关闭小程序管理员的定位验证吗？' : '确认开启小程序管理员的定位验证吗？';
      warningBox(noticeMsg).then(() => {
        updateAdminLocalVer(adminLocalVerData).then(() => {
          toast.success('更新成功');
          getAdminLocalVerData();
        });
      }).catch(() => {
        getAdminLocalVerData();
      });
    };
    const addWin = () => {
      addFormInstance.value?.open();
    };
    function search(formDara) {
      searchData = formDara;
      tableInstance.value?.load(formDara);
      getAdminLocalVerData();
    }
    function reset() {
      searchData = {};
      tableInstance.value?.load({});
    }
    function handleUpdateItem(row) {
      editFormInstance.value?.open(row.id);
    }
    function handleRemoveItem(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          tableInstance.value?.load(searchData);
        }).catch(e => {
          toast.error(e.message);
        });
      }).catch(() => {});
    }
    function tableReLoad() {
      tableInstance.value?.load(searchData);
    }
    /**
     * 编辑状态权限
     */
    const adminLoaclVerEnable = computed(() => {
      if (useStore().user.actions.filter(item => item.authorityCode === 'manage:anchor-point:adminLoaclVerFlag').length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 编辑状态权限
     */
    const useFlagEnable = computed(() => {
      if (useStore().user.actions.filter(item => item.authorityCode === 'manage:anchor-point:updateUseFlag').length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改启用状态
     * @param row
     */
    function handleUpdateUseFlag(row) {
      updateUseFlag({
        'id': row.id,
        'useFlag': row.useFlag
      }).then(() => {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    /**
     * 编辑定位权限
     */
    const locationEnable = computed(() => {
      if (useStore().user.actions.filter(item => item.authorityCode === 'manage:anchor-point:updateLocationEnable').length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改定位状态
     * @param row
     */
    function handleUpdateLocationEnable(row) {
      updateLocationEnable({
        'id': row.id,
        'locationVerification': row.locationVerification
      }).then(() => {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    /**
     * 查询指定ID的管理员定位限制状态
     */
    const getAdminLocalVerData = () => {
      getAdminLocalVer(1).then(res => {
        adminLocalVer.value = res.data.status;
      });
    };
    getAdminLocalVerData();
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_ElSwitch = _resolveComponent("ElSwitch");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_link = _resolveComponent("el-link");
      const _component_ElTableColumn = _resolveComponent("ElTableColumn");
      const _component_XFormDialog = _resolveComponent("XFormDialog");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_XSearchForm, {
          ref: "searchForm",
          items: _unref(searchFormItems),
          onSearch: search,
          onReset: reset
        }, null, 8, ["items"]), _createVNode(_component_el_row, {
          gutter: 24,
          style: {
            "margin-bottom": "20px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Plus",
              type: "primary",
              onClick: addWin
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增")])),
              _: 1
            }), _cache[3] || (_cache[3] = _createElementVNode("span", {
              style: {
                "padding": "0 6px 0 44px"
              }
            }, "小程序管理员定位验证：", -1)), _createVNode(_component_ElSwitch, {
              modelValue: _unref(adminLocalVer),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(adminLocalVer) ? adminLocalVer.value = $event : adminLocalVer = $event),
              disabled: _unref(adminLoaclVerEnable),
              "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
              "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
              onChange: _cache[1] || (_cache[1] = $event => handleUpdateAdminLocalVer())
            }, null, 8, ["modelValue", "disabled", "active-value", "inactive-value"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(XTable), {
          ref_key: "tableInstance",
          ref: tableInstance,
          url: _unref(PAGE_URL),
          selectable: false,
          "header-buttons": headerButton,
          "el-table-props": {
            border: true
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_ElTableColumn, {
            label: "操作",
            align: "center",
            width: "130"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_link, {
              underline: false,
              icon: _unref(Edit),
              type: "primary",
              onClick: $event => handleUpdateItem(row)
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("span", {
                style: {
                  "padding": "0 6px 0 4px"
                }
              }, "编辑", -1)])),
              _: 2
            }, 1032, ["icon", "onClick"]), _createVNode(_component_el_link, {
              underline: false,
              icon: _unref(Delete),
              type: "primary",
              onClick: $event => handleRemoveItem(row)
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("span", {
                style: {
                  "padding-left": "4px"
                }
              }, "删除", -1)])),
              _: 2
            }, 1032, ["icon", "onClick"])]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "锚位",
            prop: "anchorPoint"
          }), _createVNode(_component_ElTableColumn, {
            label: "经度",
            prop: "longitude",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "纬度",
            prop: "latitude",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "心跳编码",
            prop: "anchorPointHeart",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "指令编码",
            prop: "anchorPointOrder",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "锚位状态",
            prop: "status",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [row.status === '异常' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.status), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.status), 1))]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "使用标记",
            prop: "useFlag",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_ElSwitch, {
              modelValue: row.useFlag,
              "onUpdate:modelValue": $event => row.useFlag = $event,
              disabled: _unref(useFlagEnable),
              "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
              "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
              onChange: $event => handleUpdateUseFlag(row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "定位验证",
            prop: "locationVerification",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_ElSwitch, {
              modelValue: row.locationVerification,
              "onUpdate:modelValue": $event => row.locationVerification = $event,
              disabled: _unref(locationEnable),
              "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
              "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
              onChange: $event => handleUpdateLocationEnable(row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "创建者",
            prop: "nickname",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "创建时间",
            prop: "createdAt",
            align: "center",
            width: "160",
            formatter: row => _unref(formatterDate)(row.createdAt)
          }, null, 8, ["formatter"])]),
          _: 1
        }, 8, ["url"]), _createVNode(_component_XFormDialog, {
          ref_key: "editFormInstance",
          ref: editFormInstance,
          title: "编辑",
          form: {
            items: _unref(editFormItems),
            loadUrl: _unref(BASE_URL),
            saveUrl: _unref(BASE_URL),
            saveMethods: 'put',
            elFormProps: {
              rules: _unref(editRules)
            }
          },
          onSaveSuccess: tableReLoad
        }, null, 8, ["form"]), _createVNode(_component_XFormDialog, {
          ref_key: "addFormInstance",
          ref: addFormInstance,
          title: "新增",
          form: {
            items: _unref(addFormItems),
            saveUrl: _unref(BASE_URL),
            elFormProps: {
              rules: _unref(addRules)
            }
          },
          onSaveSuccess: tableReLoad
        }, null, 8, ["form"])]),
        _: 1
      });
    };
  }
});